import styled from "styled-components";
import { responsive } from "theme/responsive";

export const BannerWrapper = styled.div`
   display: flex;
   background: #f6f6fb;
   align-items: center;
   padding: 2em;

   ${responsive("$medium")`
    flex-direction: column;
    gap: 1.5em;
   `}
`;
